import { useEffect } from 'react';
import { isPlausibleConfigured } from '../lib/analytics';

/**
 * Loads Plausible when REACT_APP_PLAUSIBLE_DOMAIN is set at build time.
 * No-op when unset — app behavior is unchanged.
 */
export default function PlausibleScript() {
  useEffect(() => {
    const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    if (!domain || typeof document === 'undefined') {
      return undefined;
    }

    if (typeof window.plausible !== 'function') {
      window.plausible = function plausibleQueue() {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
    }

    if (document.querySelector('script[data-plausible="tla"]')) {
      return undefined;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.dataset.domain = domain;
    script.dataset.plausible = 'tla';
    script.src = 'https://plausible.io/js/script.js';
    document.head.appendChild(script);

    return undefined;
  }, []);

  if (!isPlausibleConfigured()) {
    return null;
  }

  return null;
}
